/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import can from 'can/util/util';
import Component from 'can/component/component';
import template from './shots-and-stats.stache';

Component.extend({
    tag: 'player-stots-and-stats',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            player: {
                Type: can.Map,
                value: null,
            },
            playerInfo: {
                Type: can.Map,
                value: null,
            },
            round: {
                type: 'number',
            },
            initialLoad: {
                type: 'bool',
            },
            showFullStats: {
                type: 'boolean',
                value: true,
            },
        },
    },
    events: {
        inserted($element) {},
    },
});
